module.exports = __webpack_public_path__ + "static/media/bolletino-form.06784e6f.svg";